/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @ts-nocheck
import { Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    root: {
        height: 'max-content',
    },
    step: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#D2D5DA',
        margin: theme.spacing(0.5),
        cursor: 'pointer',
        '-webkit-tap-highlight-color': 'transparent',
    },
    activeStep: {
        backgroundColor: theme.palette.primary.dark,
    },
}));
const Stepper = ({ steps, activeStep, onStep }) => {
    const classes = useStyles();
    return (React.createElement(Grid, { className: classes.root, container: true, direction: 'row', justifyContent: 'center', alignItems: 'center' }, Array(steps)
        .fill(1)
        .map((_, index) => (React.createElement("div", { key: `Stepper_${index}`, onClick: () => onStep(index), className: clsx(classes.step, {
            [classes.activeStep]: index === activeStep,
        }) })))));
};
export default Stepper;
